const termToFieldMapping = {
  product_category: 'field_product_category',
  region: 'field_region',
  project_type: 'field_project_type',
  topic: 'field_topic',
};

const fillOptions = (formConfig, terms) => {
  const popularTags = formConfig.find((field) => field.name === 'popular_tags');

  // Fill fields with values.
  terms.forEach((termObject) => {
    const { taxonomyMachineName, terms: options } = termObject;
    const configField = termToFieldMapping[`${taxonomyMachineName}`];

    if (configField) {
      const formFieldIndex = formConfig.findIndex((field) => {
        return field.name === configField;
      });

      formConfig[`${formFieldIndex}`].name = configField;
      formConfig[`${formFieldIndex}`].options = options.map((option) => {
        return {
          label: option.label,
          value: option.label,
        };
      });
    }

    // Fill popular tags.
    if (popularTags && popularTags.mapTo === configField) {
      const popularValues = [];
      const tagsIndex = formConfig.findIndex(
        (field) => field.name === 'popular_tags',
      );

      options.forEach((option) => {
        if (option.popular) {
          popularValues.push({
            label: option.label,
            value: option.label,
          });
        }
      });

      formConfig[`${tagsIndex}`].options = popularValues;
    }
  });

  return formConfig;
};

const fillFacets = (formConfig, facets) => {
  return formConfig.map((field) => {
    const { type, name } = field;
    let result = {};

    if (facets[`${field.name}`]) {
      if (type === 'select') {
        let options = [];
        options = options.concat({
          label: `${field.label}`,
          value: '',
        });
        Object.entries(facets[`${name}`]).forEach(([key]) => {
          options.push({
            label: `${key}`,
            value: key,
          });
        });
        field.options = options;
      }

      result = field;
    } else {
      field = null;
    }

    return result;
  });
};

const filFacetsWithCount = (formConfig, facets) => {
  return formConfig.map((field) => {
    const { type, name } = field;
    let result = {};

    if (facets[name]) {
      if (type === 'select') {
        Object.values(facets[name]).forEach(() => {
          field.options = field.options.map((option) => {
            option.label = `${option.value}`;
            option.disabled = true;
            option.count = 0;

            if (facets[name][option.value]) {
              option.label = `${option.value} (${facets[name][option.value]})`;
              option.disabled = false;
              option.count = facets[name][option.value];

              return option;
            }

            return option;
          });
        });
      }

      result = field;
    } else {
      result = field;
    }

    return result;
  });
};

const sortFacetsOptionsByCount = (formConfig) => {
  return formConfig.map((filter) => {
    if (filter.options?.length) {
      filter.options = filter.options.sort((a, b) => {
        if (
          Object.prototype.hasOwnProperty.call(a, 'count') &&
          Object.prototype.hasOwnProperty.call(b, 'count')
        ) {
          return b.count - a.count;
        }
        return 0;
      });
    }

    return filter;
  });
};

export {
  fillOptions,
  fillFacets,
  filFacetsWithCount,
  sortFacetsOptionsByCount,
};
